<template>
  <v-card>
    <v-card-title style="align-items: center"
      >{{ action === 'assistant' ? 'Add Assistant Therapist' : 'Change Therapist' }}
      <v-spacer />
      <v-btn icon @click="close">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-col class="d-flex flex-wrap" v-for="(item, i) in masterList" :key="i">
          <v-btn
            width="80"
            @click="select(item._id)"
            :class="{ active: item._id === itemSelected }"
          >
            {{ item.name }}
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions>
      <template v-if="action === 'change'">
        <v-row>
          <v-col :cols="1">
            <v-simple-checkbox v-model="noMasterSpecific" :ripple="false" />
          </v-col>
          <v-col> <span>No Requested Therapist</span> </v-col>
        </v-row>
        <v-btn
          class="mb-5 mr-5"
          color="primary"
          @click="confirmSelected(itemSelected)"
          :disabled="noConfirmed"
          >Confirm
        </v-btn>
      </template>
      <template v-if="action === 'assistant'">
        <v-row class="d-flex justify-space-between">
          <v-btn class="mb-5 ml-5" color="danger" @click="confirmSelected(null)">
            Remove Assistant
          </v-btn>
          <v-btn
            class="mb-5 mr-5"
            color="primary"
            @click="confirmSelected(itemSelected)"
            :disabled="noConfirmed"
            >Confirm
          </v-btn>
        </v-row>
      </template>
    </v-card-actions>
  </v-card>
</template>

<script>
import { listMasterProfiles } from '@/api/auth/membership';
import api from '@/api';
import { crudRead, crudUpdate } from '@/api/crud';
import { updateTimeTable } from '@/api/timetable';

export default {
  name: 'ChangeMasterDialog',
  props: {
    id: String,
    action: String,
  },
  data() {
    return {
      masterList: [],
      docs: {},
      noMasterSpecific: false,
      itemSelected: {},
      noConfirmed: true,
    };
  },
  watch: {
    id: {
      immediate: true,
      handler(v) {
        if (v) {
          this.reload();
        }
      },
    },
  },
  methods: {
    select(id) {
      this.itemSelected = id;
      this.noConfirmed = false;
      // if (this.action !== 'assistant') {
      //   this.confirmSelected(id);
      // }
    },
    async confirmSelected(id) {
      if (this.action === 'change') {
        try {
          const out = await updateTimeTable(api, this.id, {
            master: id,
          });
          if (this.noMasterSpecific) {
            await crudUpdate(api, 'rml/admin/bookings', this.docs.booking, {
              'serviceDetails.masterSpecified': null,
            });
          } else {
            await crudUpdate(api, 'rml/admin/bookings', this.docs.booking, {
              'serviceDetails.masterSpecified': id,
            });
          }
          this.$emit('update', out);
          await this.$store.dispatch('alert/updateAlertMessage', {
            msg: 'Updated Master',
            type: 'success',
            color: 'success',
          });
          this.close();
        } catch (e) {
          await this.$store.dispatch('alert/updateAlertMessage', {
            msg: e,
          });
        }
      }
      if (this.action === 'assistant') {
        try {
          const out = await updateTimeTable(api, this.id, {
            assistantMaster: id,
          });
          this.$emit('update', out);
          await this.$store.dispatch('alert/updateAlertMessage', {
            msg: 'Updated Assistant Master',
            type: 'success',
            color: 'success',
          });
          this.close();
        } catch (e) {
          await this.$store.dispatch('alert/updateAlertMessage', {
            msg: e,
          });
        }
      }
    },
    close() {
      this.$emit('close');
    },
    async reload() {
      this.masterList = (await listMasterProfiles(api)).docs;
      this.docs = await crudRead(api, 'rml/admin/timetables', this.id);
    },
  },
};
</script>

<style scoped lang="scss">
.active {
  background-color: #89c7ff !important;
}
</style>
